import { MediaType } from './media-type';

export interface Media {
  type: MediaType;
  src: string;
  description?: string;
}
